import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { OpeningLead } from './components/OpeningLead';
import { LiveActivityPopup } from './components/LiveActivityPopup';
import { LuxuryStickyBar } from './components/LuxuryStickyBar';
import { TopFlashBar } from './components/TopFlashBar';
// Lazy load below-the-fold components
const EmpathySection = lazy(() => import('./components/EmpathySection').then(m => ({
  default: m.EmpathySection
})));
const FailedSolutions = lazy(() => import('./components/FailedSolutions').then(m => ({
  default: m.FailedSolutions
})));
const TrianguloNoche = lazy(() => import('./components/TrianguloNoche').then(m => ({
  default: m.TrianguloNoche
})));
const ProductContents = lazy(() => import('./components/ProductContents').then(m => ({
  default: m.ProductContents
})));
const ObjectionsSection = lazy(() => import('./components/ObjectionsSection').then(m => ({
  default: m.ObjectionsSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const CTASection = lazy(() => import('./components/CTASection').then(m => ({
  default: m.CTASection
})));
const ClosingSection = lazy(() => import('./components/ClosingSection').then(m => ({
  default: m.ClosingSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
function SectionLoader() {
  return <div className="w-full h-32 animate-pulse bg-[var(--bg-elevated)]/50" data-id="element-0" />;
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const w = window as any;
    if (w.fbq) return;
    const fbq: any = function (...args: any[]) {
      fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [] as any[];
    w.fbq = fbq;
    w._fbq = fbq;
    fbq('init', '2190085458428751');
    fbq('track', 'PageView');
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }, []);
  return <main className="celestial-bg w-full min-h-screen bg-[var(--bg-deep)] text-[var(--text-primary)] overflow-x-hidden selection:bg-[var(--accent)] selection:text-[var(--bg-deep)]" data-id="element-1">
      <TopFlashBar data-id="element-2" />
      <LuxuryStickyBar data-id="element-3" />
      <LiveActivityPopup data-id="element-4" />

      {/* Above the fold - eager loaded */}
      <OpeningLead data-id="element-5" />

      <div className="gold-divider" data-id="element-6" />

      {/* Below the fold - lazy loaded */}
      <Suspense fallback={<SectionLoader data-id="element-8" />} data-id="element-7">
        <EmpathySection data-id="element-9" />
        <FailedSolutions data-id="element-10" />

        <div className="gold-divider" data-id="element-11" />

        <TrianguloNoche data-id="element-12" />
        <ProductContents data-id="element-13" />
        <TestimonialsSection data-id="element-14" />

        <div className="gold-divider" data-id="element-15" />

        <BonusSection data-id="element-16" />
        <CTASection data-id="element-17" />
        <ObjectionsSection data-id="element-18" />
        <ClosingSection data-id="element-19" />
        <Footer data-id="element-20" />
      </Suspense>
    </main>;
}